module.exports = __webpack_public_path__ + "static/media/ios-construct.359788e8.svg";